import {useQuery} from "@tanstack/react-query";
import {GetSEOResponse, SEOApi} from "@devour/client";
import { getViewMode } from "@/utils/platformDetection";

async function fetchSEOTags(url: string): Promise<GetSEOResponse> {
    return await new SEOApi().getSeoTags({
        url: url,
    });
}

function seoTagsQuery(url: string) {
    const isDiscordActivities = getViewMode() === "discord-activities";

    // Skip SEO tag fetching in development
    const isDevelopment = import.meta.env.DEV;

    // Check for local development URLs
    let isLocalDev = false;
    if (typeof window !== "undefined" && window.location) {
        const hostname = window.location.hostname;
        isLocalDev = hostname === "localhost" ||
                     hostname === "127.0.0.1" ||
                     hostname.includes("ngrok") ||
                     hostname.includes("tunnel") ||
                     hostname.includes("localtunnel") ||
                     hostname.endsWith(".local");
    }

    // Also check if the URL itself contains local/tunnel indicators
    const urlIsLocal = url.includes("localhost") ||
                       url.includes("127.0.0.1") ||
                       url.includes(":8085") ||
                       url.includes("ngrok") ||
                       url.includes("tunnel");

    const skipSEO = isDevelopment || isLocalDev || urlIsLocal || isDiscordActivities;

    return {
        queryKey: [
            "seo-tags",
            url,
        ],
        queryFn: () => fetchSEOTags(url),
        staleTime: 30 * 60000,
        enabled: !!url && !skipSEO,
        retry: false, // Don't retry failed requests in development
    } as const;
}

export function useGetSEOTags(url: string) {
    return useQuery(seoTagsQuery(url));
}